import { render, staticRenderFns } from "./ItemScLNewItem.vue?vue&type=template&id=9aeed2ca"
import script from "./ItemScLNewItem.vue?vue&type=script&lang=js"
export * from "./ItemScLNewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports